export const DOTS_BG_IMAGE =
  "radial-gradient(circle at 18% 18%, rgba(147, 197, 253, 0.018) 0%, transparent 30%), radial-gradient(circle at 82% 22%, rgba(191, 219, 254, 0.025) 0%, transparent 28%), linear-gradient(34.33deg, rgba(248, 250, 252, 0.24) 0%, rgba(255, 255, 255, 0.94) 100%), radial-gradient(circle, #c1c1c9 1px, transparent 1px)";

export const DOTS_BG_SIZE = "auto, auto, auto, 18px 18px";

/**
 * Karopapier: 18px minor squares with a heavier rule every fifth, drawn in the
 * brand navy. Shares the 18px pitch with DOTS_BG_IMAGE so screens using either
 * canvas stay in the same rhythm.
 */
export const GRID_PAPER_BG_IMAGE =
  "linear-gradient(34.33deg, rgba(248, 250, 252, 0.34) 0%, rgba(255, 255, 255, 0.94) 100%), " +
  "linear-gradient(to right, rgba(32, 28, 209, 0.1) 1px, transparent 1px), " +
  "linear-gradient(to bottom, rgba(32, 28, 209, 0.1) 1px, transparent 1px), " +
  "linear-gradient(to right, rgba(32, 28, 209, 0.05) 1px, transparent 1px), " +
  "linear-gradient(to bottom, rgba(32, 28, 209, 0.05) 1px, transparent 1px)";

export const GRID_PAPER_BG_SIZE =
  "auto, 90px 90px, 90px 90px, 18px 18px, 18px 18px";
